import React from "react";

export default function Spinner() {
  return (
    <div style={{ margin: "20px auto" }}>
      <div
        style={{
          border: "6px solid #f3f3f3",
          borderTop: "6px solid #ff3e3e",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          animation: "spin 1s linear infinite",
        }}
      />
      <style>{`@keyframes spin {0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}`}</style>
    </div>
  );
}

